// ISQ eligibility policy, extracted out of common.js's junk drawer for a named home —
// see .claude/context/message-history.md.

/**
 * Whether to generate initial suggested questions (ISQ). False once the customer has interacted
 * or the initial message already has ISQ; otherwise the per-surface dynamic-ISQ flags decide.
 * @param {Object} params
 * @param {Array} params.savedMessages
 * @param {string} params.channel
 * @param {boolean} params.isConsumerApp
 * @param {boolean} params.isDynamicIsqMasterEnabled
 * @param {boolean} params.isDynamicIsqDtFsEnabled
 * @param {boolean} params.isDynamicIsqMwFsEnabled
 * @param {boolean} params.isDynamicIsqAppFsEnabled
 * @param {boolean} params.isDynamicIsqValidCustomerType
 * @returns {boolean}
 */
export const checkGenerateQuestionsNeeded = ({
  savedMessages,
  channel,
  isConsumerApp,
  isDynamicIsqMasterEnabled,
  isDynamicIsqDtFsEnabled,
  isDynamicIsqMwFsEnabled,
  isDynamicIsqAppFsEnabled,
  isDynamicIsqValidCustomerType
}) => {
  const isDesktop = channel === 'desktop';
  const isMobile = channel === 'mobile' && !isConsumerApp;
  const initialMessage = savedMessages.find((msg) => msg.isInitialMessage);

  const hasCustomerInteracted = savedMessages.length > 1;
  const isISQExistsForInitialMessage = initialMessage?.content?.relatedQuestions?.suggestedQuestions?.length > 0;

  if (isISQExistsForInitialMessage || hasCustomerInteracted) return false;

  const enableForDesktop = isDesktop && isDynamicIsqDtFsEnabled;
  const enableForMobile = isMobile && isDynamicIsqMwFsEnabled;
  const enableForApp = isConsumerApp && isDynamicIsqAppFsEnabled;
  const shouldCallGenerateQuestions = isDynamicIsqMasterEnabled
    && isDynamicIsqValidCustomerType
    && (enableForDesktop || enableForMobile || enableForApp);
  return shouldCallGenerateQuestions;
};
